const locale = {
  'demandList.btn.totalMessage': 'Всего: {skuTotal} SKU, всего {productTotal} товаров',
  'demandList.btn.deleteProduct': 'Удалить товар',
  'demandList.btn.clearQuantity': 'Очистить количество',
  'demandList.btn.exportSelectedProducts': 'Экспортировать выбранные товары',
  'demandList.btn.moveToOtherLists': 'Переместить в другие списки',

  'demandList.message.deleting': 'Удаление...',
  'demandList.message.deleteSuccessfully': 'Успешно удалено',
  'demandList.message.deleteFailed': 'Ошибка удаления',

  'demandList.message.clearing': 'Очистка...',
  'demandList.message.clearQuantitySuccessfully': 'Количество успешно очищено',
  'demandList.message.clearQuantityFailed': 'Ошибка очистки количества',

  'demandList.message.exporting': 'Экспорт...',
  'demandList.message.exportFailed': 'Ошибка экспорта',

  'demandList.exported.message': 'Выбранные товары экспортированы',
  'demandList.exported.description': 'Вы можете просмотреть их в загруженных файлах браузера',

  'demandList.title': '< Список запросов',
  'demandList.inquiry.noproduct': 'Пожалуйста, выберите товар',
  'demandList.inquiry.productAllZero': 'Пожалуйста, введите количество товара',
  'demandList.inquiry.prompt.title': 'Подсказка',
  'demandList.inquiry.quantityprompt.title': 'Подсказка',
  'demandList.inquiry.quantityprompt.content':
    'Некоторые товары имеют количество 0. При продолжении запроса товары с количеством 0 не будут отправлены',
  'demandList.inquiry.quantityprompt.ok': 'Продолжить запрос',
  'demandList.inquiry.quantityprompt.cancel': 'Завершить',
  'demandList.inquiry.success': 'Запрос успешно отправлен',
  'demandList.inquiry.check.content':
    'После подтверждения мы оперативно обработаем ваш запрос. Обновления будут отправлены по электронной почте, WhatsApp или телефону',
  'demandList.inquiry.check.clear.content': 'Удалить отправленные товары',
  'demandList.inquiry.check.notclear.content': 'Не удалять отправленные товары',
  'demandList.inquiry.textarea.placeholder':
    'Если вы не можете найти нужные аксессуары или у вас есть особые требования к качеству и срокам доставки, укажите их здесь',
  'demandList.inquiry.attachment.filetypeerror': 'Неверный формат файла',
  'demandList.inquiry.attachment.filesizeerror': 'Размер файла превышает лимит',
  'demandList.inquiry.attachment.btn': 'Загрузить вложение',
  'demandList.inquiry.attachment.accepttext':
    'Поддерживаются форматы .pdf, .xlsx, .doc, .png, .jpg. Загрузите до 5 файлов, каждый файл не более 10M',
  'demandList.inquiry.btn': 'Отправить запрос',
  'demandList.move.title': 'Переместить в другой список',
  'demandList.move.content':
    'После сохранения выбранные товары будут перемещены в целевой список запросов. Если список не существует, вы можете создать его самостоятельно, максимум 7 списков',
  'demandList.move.input.placeholder': 'Создать список запросов, нажмите Enter для сохранения',
  'demandList.move.unsave': '(не сохранено)',
  'demandList.move.select.maxlength': 'Максимум 7 элементов',
  'demandList.move.success': 'Успешно перемещено',
  'demandList.versions.current': 'Текущий',
  'demandList.versions.deleteprompt.title': 'Подтвердить удаление',
  'demandList.versions.deleteprompt.content':
    'После удаления список запросов не может быть восстановлен. Вы уверены, что хотите удалить?',
  'demandList.versions.edit.title': 'Редактировать',
  'demandList.versions.input.placeholder': 'Введите',

  'demandList.modal.okText': 'Подтвердить',
  'demandList.modal.cancelText': 'Отмена',

  'demandList.modal.title.delete': 'Подтвердить удаление товаров?',
  'demandList.modal.content.delete': 'После подтверждения выбранные товары будут удалены',
  'demandList.modal.title.clear': 'Подтвердить очистку количества?',
  'demandList.modal.content.clear':
    'После подтверждения количество выбранных товаров будет сброшено на 0',
};

export default locale;
